import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GraphChange } from 'libs/portal/src/models/GraphChange';
import { TimeFrame } from 'libs/portal/src/models/types/Timeframes';
import { TimePeriod } from 'libs/portal/src/models/types/TimePeriods';
import { GenericGraphComponent } from '../generic-graph/generic-graph.component';

@Component({
  selector: 'app-generic-graph-handler',
  templateUrl: './generic-graph-handler.component.html',
  styleUrls: ['./generic-graph-handler.component.scss'],
})
export class GenericGraphHandlerComponent implements OnInit, AfterViewInit {
  @ViewChild('GraphChild', { static: false }) public GraphChild: GenericGraphComponent;

  @Output() changed: EventEmitter<GraphChange> = new EventEmitter<GraphChange>();
  @Output() selected: EventEmitter<any> = new EventEmitter<any>();
  @Input() graphData: GraphChange;
  @Input() showTools = true;
  @Input() showDataLabels = true;
  @Input() colors: string[];
  @Input() enableDataLabels = true;
  @Input() formatXAxisDate = true;

  // @Input() TimeFilters: Filter[];
  // selectedInterval: Filter;

  constructor() {}

  ngOnInit() {
    this.graphData.Callback = this.transformAndPopulate;
    this.graphData.GraphHandler = this;
  }

  ngAfterViewInit(): void {
    this.transformAndPopulate(this.graphData);
  }

  updateSelectedTimeFilter(eve) {
    this.graphData.Interval = eve.name;
    this.emitToParent();
  }

  updateStart(newDate: string) {
    this.graphData.StartDate = newDate;
    // this.emitToParent();
  }

  updateEnd(newDate: string) {
    let d = new Date(newDate);
    let date = new Date(newDate.substr(0, 10));
    date.setHours(d.getUTCHours());
    date.setMinutes(d.getUTCMinutes());
    date.setSeconds(d.getUTCSeconds());
    let today = new Date();
    if (today.getUTCFullYear() == date.getUTCFullYear() && today.getUTCMonth() == date.getUTCMonth() && today.getUTCDate() == date.getUTCDate()) {
      date.setHours(today.getHours() + 2);
      date.setMinutes(today.getUTCMinutes() - 5);
      date.setSeconds(0);
      date.setMilliseconds(0);
      newDate = date.toISOString();
    }

    this.graphData.EndDate = newDate;
  }
  timeFrameSelected(timeFrame: TimeFrame) {
    this.graphData.TimeFrame = timeFrame;
    this.emitToParent();
  }

  timePeriodSelected(timePeriod: TimePeriod) {
    this.graphData.Timeperiod = timePeriod;
    this.emitToParent();
  }

  intervalInputChanged(interval: number) {
    this.graphData.Interval = interval;
    this.emitToParent();
  }

  emitToParent() {
    // console.trace();
    setTimeout(() => {
      this.GraphChild.setGraphLoading();
      this.changed.emit(this.graphData);
    });
  }

  notify(ev) {
    if (this.selected != null) {
      this.selected.emit(ev);
    }
  }

  transformAndPopulate(c: GraphChange) {
    c.Transformer(c);
    this.graphData = c;
    c.GraphHandler.GraphChild.setGraphData(c);
  }
}
